/**
 * 개발 도구 — 일일 보안 점검 (/adm/dev/security-check)
 * ($j.Pages.Admin.SecurityCheck / body data-page-name="SecurityCheck")
 *
 * 주 단위 점검 결과 달력 + 날짜별 상세. 조회 전용이다.
 * 요약·이슈·근거에는 공격자가 보낸 URI·UA 가 그대로 섞일 수 있으니 전부 escapeHtml 을 거친다.
 */
export default class SecurityCheck {
    initialize() {
        loadWeek('');

        $('#btnPrevWeek').on('click', () => loadWeek($('#btnPrevWeek').data('go')));
        $('#btnNextWeek').on('click', () => loadWeek($('#btnNextWeek').data('go')));
        $('#btnThisWeek').on('click', () => loadWeek(''));

        $(document).on('click', '.dc-day:not(.is-empty)', function () {
            $('.dc-day').removeClass('is-active');
            $(this).addClass('is-active');
            openDetail($(this).data('num'));
        });

        $('#btnToggleMd').on('click', () => $('#detailMd').toggle());
    }
}

function loadWeek(week) {
    $.post('/adm/ajax/dev/security-check/list', { week: week }, function (res) {
        if (!res.result) return;

        $('#weekLabel').text(res.week.label + (res.week.current ? ' (이번 주)' : ''));
        $('#btnPrevWeek').data('go', res.week.prev);
        $('#btnNextWeek').data('go', res.week.next).prop('disabled', res.week.current);

        renderDays(res.days, res.labels);
        renderWeekIssues(res.issues);

        // 가장 최근 리포트를 기본으로 펼친다
        const last = [...res.days].reverse().find(d => d.report);
        if (last) {
            $('.dc-day[data-num="' + last.report.num + '"]').addClass('is-active');
            openDetail(last.report.num);
        } else {
            $('#detailTitle').text('리포트 상세');
            $('#detailBody').html('<span class="dc-muted">이 주에는 점검 기록이 없습니다.</span>');
            $('#detailMd').hide().empty();
        }
    });
}

function renderDays(days, labels) {
    $('#days').html(days.map(function (d) {
        const md = d.date.substring(5).replace('-', '/');
        const dowCls = d.dow === '일' ? 'dc-day-sun' : (d.dow === '토' ? 'dc-day-sat' : '');

        if (!d.report) {
            return `<div class="dc-day is-empty">
                        <div class="dc-day-head"><span class="dc-day-date ${dowCls}">${md} (${d.dow})</span></div>
                        <div class="dc-muted dc-day-empty">${d.future ? '' : '기록 없음'}</div>
                    </div>`;
        }

        const r = d.report;
        const checks = (r.checks || []).map(c =>
            `<div class="dc-check"><span class="dc-dot ${dotClass(c.result)}"></span>${escapeHtml(labels[c.key] || c.key)}</div>`
        ).join('');
        const issueCnt = (r.issues || []).length;

        return `<div class="dc-day" data-num="${parseInt(r.num, 10)}">
                    <div class="dc-day-head">
                        <span class="dc-day-date ${dowCls}">${md} (${d.dow})</span>
                        ${resultBadge(r.result)}
                    </div>
                    <div class="dc-checks">${checks}</div>
                    ${issueCnt ? `<div class="dc-day-issues">이슈 ${issueCnt}건</div>` : ''}
                </div>`;
    }).join(''));
}

function renderWeekIssues(issues) {
    $('#issueCount').text(issues.length ? issues.length + '종' : '');

    if (!issues.length) {
        $('#weekIssues').html('<span class="dc-muted">이번 주 잡힌 이슈가 없습니다.</span>');
        return;
    }

    $('#weekIssues').html(issues.map(it =>
        `<div class="dc-issue ${sevClass(it.severity)}">
            <div class="dc-issue-title">${sevBadge(it.severity)} ${escapeHtml(it.title)}</div>
            <div class="dc-issue-meta">
                ${parseInt(it.days, 10)}일 발생
                ${it.hosts && it.hosts.length ? ' · ' + escapeHtml(it.hosts.join(', ')) : ''}
                · 최근 ${escapeHtml(it.last)}
            </div>
            ${actionRow(it.action)}
        </div>`
    ).join(''));
}

function openDetail(num) {
    $.post('/adm/ajax/dev/security-check/detail', { num: num }, function (res) {
        if (!res.result) return;
        const r = res.report;

        $('#detailTitle').html(
            `${escapeHtml(r.check_date)} 리포트 ${resultBadge(r.result)}
             <small class="text-muted ml-2">${escapeHtml(r.updated_at)}</small>`
        );

        const checks = (r.checks || []).map(c =>
            `<div class="dc-detail-check">
                <div class="lbl"><span class="dc-dot dc-dot-inline ${dotClass(c.result)}"></span>${escapeHtml(c.label)}</div>
                <div class="dtl">${escapeHtml(c.detail || '-')}</div>
             </div>`
        ).join('');

        const issues = (r.issues || []).length
            ? r.issues.map(it =>
                `<div class="dc-issue ${sevClass(it.severity)}">
                    <div class="dc-issue-title">${sevBadge(it.severity)} ${escapeHtml(it.title || '')}</div>
                    ${it.hosts && it.hosts.length ? `<div class="dc-issue-meta">${escapeHtml(it.hosts.join(', '))}</div>` : ''}
                    ${actionRow(it.action)}
                    ${it.evidence && it.evidence.length ? `<div class="dc-samples">${escapeHtml(it.evidence.join('\n'))}</div>` : ''}
                 </div>`
              ).join('')
            : '<div class="dc-muted">잡힌 이슈 없음 — 전 항목 정상입니다.</div>';

        $('#detailBody').html(
            `<div class="dc-detail-summary">${escapeHtml(r.summary || '')}</div>
             <div class="dc-detail-checks">${checks}</div>
             ${issues}`
        );

        // body 는 서버에서 raw HTML 을 걷어낸 마크다운 렌더 결과다
        $('#detailMd').html(r.body || '<span class="dc-muted">본문 없음</span>').hide();
    });
}

function actionRow(action) {
    return action ? `<div class="dc-issue-row"><b>조치</b><span>${escapeHtml(action)}</span></div>` : '';
}

function resultBadge(result) {
    return result === 'ISSUE' ? '<span class="st st-issue">이상</span>' : '<span class="st st-ok">정상</span>';
}

function dotClass(result) {
    if (result === 'OK') return 'dc-dot-ok';
    if (result === 'ISSUE') return 'dc-dot-issue';
    return 'dc-dot-unknown';
}

function sevClass(severity) {
    return 'dc-issue-' + (severity === 'high' || severity === 'mid' ? severity : 'low');
}

function sevBadge(severity) {
    const map = { high: ['st-issue', '높음'], mid: ['st-run', '보통'], low: ['st-none', '낮음'] };
    const [cls, txt] = map[severity] || map.low;
    return `<span class="st ${cls}">${txt}</span>`;
}

function escapeHtml(str) {
    return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
